import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ExpertisePage = lazy(() => import('../pages/expertise/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ReferencesPage = lazy(() => import('../pages/references/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const AppointmentPage = lazy(() => import('../pages/appointment/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/notre-adn',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/expertises-realisations',
    element: <ExpertisePage />,
  },
  {
    path: '/expertise',
    element: <ExpertisePage />,
  },
  {
    path: '/references',
    element: <ReferencesPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/appointment',
    element: <AppointmentPage />,
  },
  {
    path: '/mentions-legales',
    element: <LegalPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;